import React from 'react';
import Banner from './Banner';
import Contact from './Contact';
import Items from './Items';

const Home = () => {
  return (
    <div>
      <Banner></Banner>
      <Items></Items>
      <Contact></Contact>
    </div>
  );
};

export default Home;
